/**
 * 🗓 [실사 취소] 확인 창 (v2.225.0 · 2026-10-01) — 앱(분기 고르기·목록·마침)과 PC [분기 실사] 탭이 같이 쓴다.
 *
 * ⭐되돌릴 수 없다(기록·사진 NAS 파일까지 지운다) → 무엇이 지워지는지 숫자로 보여 준다.
 * ⭐확인한 품목이나 사진이 하나라도 있으면 **「삭제」 두 글자 입력**을 한 번 더 받는다 —
 *   남이 세던 실사를 손가락 한 번에 날리지 않게. 아무것도 안 했으면(시작만) 확인 한 번으로 끝.
 */

export interface CancelTarget {
  /** 「2026년 3분기」 */
  label: string;
  /** 맞음·다름·무시로 확인한 품목 수 */
  decided: number;
  /** 그 실사에 남은 사진 장수 */
  photos: number;
  /** 🔎 수시 실물확인인가 (v2.324.0) — 문구가 「실사」·「같은 분기」 대신 「수시 실물확인」 */
  adhoc?: boolean;
}

export const CANCEL_TYPE_WORD = '삭제';

export function cancelConfirmText(t: CancelTarget): string {
  const lines = [t.adhoc ? `수시 실물확인 「${t.label}」 — 취소합니다.` : `${t.label} 실사를 취소합니다.`, ''];
  if (t.decided > 0 || t.photos > 0) {
    if (t.decided > 0) lines.push(`· 확인한 품목 ${t.decided}종의 기록`);
    if (t.photos > 0) lines.push(`· 사진 ${t.photos}장 (NAS 파일도 함께)`);
    lines.push('모두 지워지고 되돌릴 수 없습니다.');
  } else {
    lines.push('아직 확인한 품목도 사진도 없습니다.');
  }
  lines.push(t.adhoc ? '취소한 뒤에는 새 수시 실물확인을 시작할 수 있습니다.' : '취소한 뒤에는 같은 분기를 처음부터 다시 시작할 수 있습니다.');
  return lines.join('\n');
}

/** 확인 창(+필요하면 「삭제」 입력) — 끝까지 동의하면 true */
export function confirmCancelAudit(t: CancelTarget): boolean {
  if (!window.confirm(cancelConfirmText(t))) return false;
  if (t.decided === 0 && t.photos === 0) return true;
  const typed = window.prompt(`되돌릴 수 없습니다. 정말 지우려면 「${CANCEL_TYPE_WORD}」 두 글자를 입력하세요.`);
  if (typed === null) return false;
  if (typed.trim() !== CANCEL_TYPE_WORD) {
    window.alert(`입력한 글자가 「${CANCEL_TYPE_WORD}」와 달라 취소하지 않았습니다.`);
    return false;
  }
  return true;
}

/** 끝난 뒤 띠 문구 */
export function cancelDoneText(r: { label: string; decided: number; photosDeleted: number; photosMissing: number }, adhoc = false): string {
  const parts: string[] = [];
  if (r.decided > 0) parts.push(`확인 기록 ${r.decided}종`);
  if (r.photosDeleted > 0) parts.push(`사진 ${r.photosDeleted}장(NAS 파일 포함)`);
  if (r.photosMissing > 0) parts.push(`NAS 에 이미 없던 사진 기록 ${r.photosMissing}장`);
  const what = parts.length ? ` — ${parts.join(' · ')} 지움` : '';
  return adhoc
    ? `수시 실물확인 「${r.label}」 취소 끝${what}.`
    : `${r.label} 실사를 취소했습니다${what}. 같은 분기를 다시 시작할 수 있습니다.`;
}
